import styled from "styled-components";
import { MainButton } from "../../styles/GlobalStyledComponents";

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 10px 0;
  height: 100%;
  flex-grow: 1;
`;

export const CardInfoText = styled.h3`
  color: ${(props: any) => props.theme.colors.highEmphasisText};
  font-weight: bolder;
`;

export const CardInfoMessage = styled.p`
  font-size: 14px;
`;

export const CardErrorButton = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const ErrorCardTextWrapper = styled.div`
    justify-content: center;
    display: flex;
    flex-direction: column;
`;

export const ButtonAdd = styled(MainButton)`
  font-size: 16px;
  margin: 20px 0 10px 0;
`;
